var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('iframe',{staticStyle:{"border":"none","overflow":"hidden"},attrs:{"src":_vm.fullUrl,"width":"77","height":"28","scrolling":"no","frameborder":"0","allowfullscreen":"true","allow":"autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"}})
}
var staticRenderFns = []

export { render, staticRenderFns }